import { create } from 'zustand';

import type { BreadcrumbItem, BreadcrumbState } from './types';

type BreadcrumbStore = BreadcrumbState & {
  setBreadcrumbs: (breadcrumbs: BreadcrumbItem[]) => void;
  clearBreadcrumb: () => void;
  addBreadcrumb: (breadcrumb: BreadcrumbItem) => void;
  removeBreadcrumb: (index: number) => void;
  updateBreadcrumb: (payload: { index: number; breadcrumb: BreadcrumbItem }) => void;
};

const initialState: BreadcrumbState = {
  breadcrumbs: []
};

export const useBreadcrumbStore = create<BreadcrumbStore>(set => ({
  ...initialState,
  setBreadcrumbs: breadcrumbs => set({ breadcrumbs }),
  clearBreadcrumb: () => set({ breadcrumbs: [] }),
  addBreadcrumb: breadcrumb => set(state => ({ breadcrumbs: [...state.breadcrumbs, breadcrumb] })),
  removeBreadcrumb: index =>
    set(state => ({
      breadcrumbs: state.breadcrumbs.filter((_, i) => i !== index)
    })),
  updateBreadcrumb: ({ index, breadcrumb }) =>
    set(state => {
      if (index < 0 || index >= state.breadcrumbs.length) {
        return state;
      }
      const next = [...state.breadcrumbs];
      next[index] = breadcrumb;
      return { breadcrumbs: next };
    })
}));
